import React, { FormEvent, useState, useEffect, useContext } from "react";
import { RouteProps } from "react-router-dom";
import AuthContext from "../../../contexts/AuthContext";

import TextArea from "../../../components/Form/TextArea";
import Button from "../../../components/Form/Button";

import { SimpleResponse } from "../../../services/api/Request";
import Actual, { IMessage } from "../../../services/api/Actual";
import { SetModal } from "../../../components/Modal";
import ImgPlaceholder from "./assets/images/placeholder.svg";

import "./assets/css/message.css";

interface FormProps extends RouteProps {
    actualId: number;
    groupId: Number;
    monthId: Number;
    currentYear: Number;
}

const Message: React.FC<FormProps> = ({ actualId, groupId, monthId, currentYear}) => {
  const monthShortNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];
  const { user } = useContext(AuthContext);
  const [response, setResponse] = useState<SimpleResponse>();
  const [loading, isLoading] = useState<Boolean>(true);
    const [messages, setMessages] = useState<IMessage[]>([]);
    const [message, setMessage] = useState<string>('');

    async function LoadMessage(id: Number) {
        const resp: IMessage[] = await Actual.GetMessages(id);
        isLoading(false);
        setMessages(resp);
    }

  useEffect(() => {
      LoadMessage(actualId);
  }, []);

  async function handleFormSubmit(event: FormEvent) {
    event.preventDefault();
    const formData: FormData = new FormData(event.target as HTMLFormElement);
    let data: any = {
        actualId: actualId,
        groupId: groupId,
        monthId: monthId,
        currentYear: currentYear,
      user: user
    };
    formData.forEach((value: FormDataEntryValue, key: string) => {
      data[key] = value;
    });
      
      let resp: any = undefined;
      if (data.message.length > 0 && !!data.message.trim())
          resp = await Actual.CreateMessage(data);
      else 
          resp = { status: 450, message: "Digit your message before sending" };

      setResponse(resp);      
  }

  function formatDate(value: Date): string {
    value = new Date(value);
    let hours: number = value.getHours();
    const minutes: number = value.getMinutes();
    const ampm: string = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    return (
      monthShortNames[value.getMonth()] +
      ", " +
      value.getDate() +
      " - " +
      value.getFullYear() +
      " | " +
      hours +
      ":" +
      (minutes < 10 ? "0" : "") +
      minutes +
      " " +
      ampm
    );
  }

  function renderRow(message: IMessage) {
    const mystyles = {
        background: `url(${message.user.picture || ImgPlaceholder})`
    } as React.CSSProperties;

    return (
      <li key={message.id}>
        <article className="comments__item">
          <header className="comments__header">
            <div className="comments__pic" style={mystyles}></div>
            {/* <img className="comments__pic" src={message.user.picture} alt={message.user.name} /> */}
            <h1 className="comments__name">
              {message.user.name} - {message.user.group.code} |{" "}
              {message.user.profile.name}
            </h1>
          </header>
          <p className="comments__info">
            <span className="comments__date">
              {formatDate(message.creationDate)}
            </span>
          </p>
          <div className="comments__text">{message.message}</div>
        </article>
      </li>
    );
    }

  return (
    <React.Fragment>
      <div className="comments">
        <div className="row">
          <div className="col--2">
            <h3 className="comments__title">Comments</h3>
            <h4 className="comments__subtitle">
              Please use this space to
              <br /> let your comments
            </h4>
            {response ? SetModal.FromResponse(response, () => {
                setResponse(undefined);
                if (response.status === 200) {      
                    setMessage('');
                    if (actualId === 0)
                        window.location.reload();
                    else
                      LoadMessage(actualId);
                }
            }) : null}
            <form className="container" onSubmit={handleFormSubmit}>
              <TextArea name="message" placehold="Your comments" value={message} onChange={(e: any) => { setMessage(e.target.value); } } />
              <Button
                className="button button--big button--darkblue"
                title="Send"
              />
            </form>
          </div>

          <div className="col--2 comments--left-space">
            <div className="comments__list">
              <h4 className="comments__list-title">Latest Comments</h4>
              {loading ? (
                <span>Loading...</span>
              ) : (
                <ul>{messages.map(renderRow)}</ul>
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Message;
